import React from 'react'
import { Flex } from 'styling/GlobalStyles'
import { BodyText, TitleText } from 'styling/Typography'
import { CardWrapper } from './DisplayCard.styled'

interface IDisplayCardProps {
  value: string | number
  label: string
  borderColor?: string
  icon?: React.ReactNode
}

export const DisplayCard = ({ value, label, borderColor, icon }: IDisplayCardProps) => {
  return (
    <CardWrapper $borderColor={borderColor}>
      {icon}
      <Flex column gap='2px'>
        <BodyText style={{ fontSize: 24, lineHeight: '32px' }} weight='bold'>
          {value}
        </BodyText>
        <TitleText style={{ lineHeight: '16px' }} grey>
          {label}
        </TitleText>
      </Flex>
    </CardWrapper>
  )
}
